import styled from 'styled-components';

export const StyledPicture = styled.picture`
  height: inherit !important;
`;

export const StyledImg = styled.img`
  border-radius: ${({ radius }) => radius};
`;

export default { StyledPicture };
